import getInstance from './instanceBBA';

const instance = getInstance();

export const addShippingAddress = (payload) => {
  const url = 'user/address';
  return instance.post(url, payload);
};
